import { mutate } from '../../core/createApolloClient/createApolloClient.client';
import { getp } from '../../helpers/getProp';
import gql from 'graphql-tag';

const mutation = gql`
  mutation sendMessage(
    $threadId: Int!
    $reservationId: Int
    $content: String
    $eventName: String
  ) {
    sendMessage(
      threadId: $threadId
      reservationId: $reservationId
      content: $content
      eventName: $eventName
    ) {
      id
    }
  }
`;

const denyReservationMFn = async function({ id, threadId }) {
  const results = await mutate(mutation, {
    threadId,
    content: '',
    eventName: 'declined',
    reservationId: id,
  });
  const success = getp(results, 'data.sendMessage.id');
  if (success) {
    return true;
  } else {
    console.log('ERR - denyReservationMFn - Mutation failed', results);
    return false;
  }
};

export default denyReservationMFn;



// WEBPACK FOOTER //
// ./src/mobxStores/Inbox/denyReservationMFn.js